import { useCurrenciesQuery } from '@/api/config';

export const useCurrencyPrecision = (currencyPair: string | undefined) => {
  const { data: currenciesData } = useCurrenciesQuery();

  const currencyPairData = currenciesData?.dict[currencyPair ?? ''];

  return currencyPairData?.precision ?? 5;
};
